/*
 *
 * Kibana constants
 *
 */

export const DEFAULT_ACTION = 'app/Kibana/DEFAULT_ACTION';
